import { Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { ToastService } from "@app/services";
import { StateStatus } from "@app/state/model";
import { selectChecklistLinesStatus } from "@app/state/selectors";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import { filter, map, take, tap } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class ChecklistLineGuard implements CanActivate {
  constructor(private store: Store, private toastService: ToastService) {}

  waitForChecklistLinesToLoad(): Observable<boolean> {
    return this.store.select(selectChecklistLinesStatus).pipe(
      tap((status) => {
        if (status === StateStatus.Pending || status === StateStatus.Loading) {
          this.toastService.show("Checklist Lines loading...");
        } else if (status === StateStatus.Error) {
          this.toastService.show("Checklist Lines failed to load...");
        }
      }),
      filter(
        (status) =>
          status === StateStatus.Success || status === StateStatus.Error
      ),
      map((status) => status === StateStatus.Success),
      take(1)
    );
  }

  canActivate(): Observable<boolean> {
    return this.waitForChecklistLinesToLoad();
  }
}
